/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ grower: NonNullable<unknown>, area: NonNullable<unknown> }} Camera_Overview_LocationInputs */

const vi_camera_overview_location = /** @type {(inputs: Camera_Overview_LocationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.grower} · ${i?.area}`)
};

/**

* @param {Camera_Overview_LocationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_overview_location = /** @type {((inputs: Camera_Overview_LocationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Overview_LocationInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_overview_location(inputs)
});